import * as Yup from 'yup';

export const commonPromptYopValidation = () => {
  return Yup.object().shape({
    description: Yup.string().required('required'),
  });
};
